import "../App.css";
//import "./home.css";
import React, { useState, useEffect } from "react";
import { LoadingPage } from "../loading/LoadingPage";
import { NavigationBar } from "../navigation/NavigationBar";

import { useParams, Link } from "react-router-dom";
import { call, home } from "../service/ApiService";
import {
  Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
  ListItem,
  ListItemText,
  InputBase,
  Checkbox,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from "@mui/material";

export function Upbit() {
  let subject = "upbit 외부 API";
  let navigationBar = NavigationBar(subject);

  const [items, setItems] = useState({});
  const [loading, setLoading] = useState(0);

  //<Checkbox checked={item.done} onChange={checkboxEventHandler} />

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/api/upbit", "GET", "").then((response) => {
      //console.log(response.data);
      if (!response) {
        alert("권한 없음.");
        window.location.href = "/home";
        return;
      }
      if (response.error) {
        alert("누구냐 넌 : " + response.error);
        window.location.href = "/home";
        return;
      }
      if (response.data) {
        setItems(response.data[0]);
        console.log(response.data[0]);
        setLoading(1);
      }
    });
  }, []);

  let menu = (
    <Paper style={{ margin: 16 }}>
      <List className="menu">
        <div>{"Menu"}</div>
        <ListItem>
          <Link to="/home" variant="2">
            상위단계 home
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>메인페이지로 이동.</ListItemSecondaryAction>
        </ListItem>
      </List>
    </Paper>
  );

  if (loading == 0) {
    menu = <div>loading...</div>;
  } else {
  }

  let todoItems = items.length > 0 && (
    <div>
      {items["market"]}
      <h3>
        {items.map((item, i) => (
          <span item={item} key={i}>
            {item}
            {"   "}
          </span>
        ))}
      </h3>
    </div>
  );

  todoItems = (
    <div>
      <div>market : {items["market"]}</div>
      <div>trade_date : {items["trade_date"]}</div>
      <div>trade_time : {items["trade_time"]}</div>
      <div>trade_date_kst : {items["trade_date_kst"]}</div>
      <div>trade_time_kst : {items["trade_time_kst"]}</div>
      <div>highest_52_week_date : {items["highest_52_week_date"]}</div>
      <div>lowest_52_week_date : {items["lowest_52_week_date"]}</div>
    </div>
  );

  let content;
  /* 로딩중이 아닐 때 렌더링 할 부분 */
  let framePage = (
    <div>
      {navigationBar} {/* 네비게이션 바 렌더링 */}
      <Container maxWidth="md">{""}</Container>
      <Container maxWidth="md">{menu}</Container>
      <Container maxWidth="md">{todoItems}</Container>
    </div>
  );

  content = framePage;
  return <div className="App">{content}</div>;
}
